module.exports = global["Player"] = require("-!/mnt/jenkins/var-lib-jenkins/jobs/animoto_player_deploy/workspace/node_modules/babel-loader/index.js!/mnt/jenkins/var-lib-jenkins/jobs/animoto_player_deploy/workspace/node_modules/string-replace-webpack-plugin/loader.js?id=f4n90pf4r9vygb9!/mnt/jenkins/var-lib-jenkins/jobs/animoto_player_deploy/workspace/src/player.js");


/*****************
 ** WEBPACK FOOTER
 ** ./src/player.js
 ** module id = 0
 ** module chunks = 0
 **/